import { executeFetch } from '@unifyapps/network/utils/fetch';

function isPrivateUrl(url: string): boolean {
  return url.includes('api/file/download/__UNIFY_ENCR_AWS__');
}

async function resolveUrl(url: string) {
  if (isPrivateUrl(url)) {
    try {
      // The redirect URL is in the response headers and not returned in the response body
      const res = await executeFetch<Response>(
        { url, method: 'GET' },
        { credentials: 'include', returnRawResponse: true },
      );
      if (!res.ok) {
        console.error(`Failed to fetch URL: ${url}, Status: ${res.status}`);
        return url;
      }

      // The redirect URL is in the response headers and not returned in the response body
      return res.url;
    } catch (error) {
      console.error(`Error fetching URL: ${url}`, error);
      return url;
    }
  }

  return url;
}

export { resolveUrl, isPrivateUrl };
